<template>
  <div class="page-bottom">
    <div class="information" style="padding-top: 20px;">
		<div v-if="bedInfoByIdInformationList && bedInfoByIdInformationList.length > 0" style="display: flex; padding-left: 20px; padding-right: 20px;">
			<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #262626; line-height: 20px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 58px; margin-right: 14px;">{{ bedInfoByIdInformationList[0].name }}</div>
			<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #262626; line-height: 20px; text-align: center; margin-right: 14px;">{{ bedInfoByIdInformationList[0].sexName }}</div>
			<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #262626; line-height: 20px;">{{ bedInfoByIdInformationList[0].ageGroupName }}</div>
		</div>
		<div v-if="!bedInfoByIdInformationList || bedInfoByIdInformationList.length == 0 || (!bedInfoByIdInformationList[0].name && !bedInfoByIdInformationList[0].sexName && !bedInfoByIdInformationList[0].ageGroupName)" style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #8C8C8C; line-height: 20px; width: 160px; margin-left: 20px;">提供用户基本信息，数据会更加精准</div>
		<div v-if="roleId == 3 && selectLivingState" style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #262626; line-height: 20px; width: 160px; margin-left: 20px; margin-top: 8px;">{{selectLivingState}}</div>
		<div v-if="roleId == 2" style="display: flex; align-items: center; justify-content: center; margin-top: 7px;" :style="{marginTop: !bedInfoByIdInformationList || bedInfoByIdInformationList.length == 0 || (!bedInfoByIdInformationList[0].name && !bedInfoByIdInformationList[0].sexName && !bedInfoByIdInformationList[0].ageGroupName) ? '15px' : '7px'}">
			<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #8C8C8C; line-height: 20px; margin-right: 5px;">行为状态</div>
			<a-select
				v-if="isLoadLivingState && selectLivingState"
				placeholder="请选择"
				v-model="selectLivingState"
				option-filter-prop="children"
				style="width: 99px;"
				:filter-option="filterOption"
				@focus="handleFocus"
				@blur="handleBlur"
				@change="handleChange"
				dropdownClassName="my-ant-select-dropdown"
				class="my-ant-select"
			>
				<a-select-option :value="item.name" :key="index" v-for="(item, index) in living_state">
					{{ item.name }}
				</a-select-option>
			</a-select>
			<a-select
				v-if="isLoadLivingState && !selectLivingState"
				placeholder="请选择"
				option-filter-prop="children"
				style="width: 99px;"
				:filter-option="filterOption"
				@focus="handleFocus"
				@blur="handleBlur"
				@change="handleChange"
				dropdownClassName="my-ant-select-dropdown"
				class="my-ant-select"
			>
				<a-select-option :value="item.name" :key="index" v-for="(item, index) in living_state">
					{{ item.name }}
				</a-select-option>
			</a-select>
		</div>
		<div v-if="bedInfoByIdInformationList && bedInfoByIdInformationList.length > 0 && ((bedInfoByIdInformationList[0].name && bedInfoByIdInformationList[0].name.length > 0) || (bedInfoByIdInformationList[0].sexName && bedInfoByIdInformationList[0].sexName.length > 0) || (bedInfoByIdInformationList[0].ageGroupName && bedInfoByIdInformationList[0].ageGroupName.length > 0)) " class="look" @click="checkInfo" style="margin-top: 8px;">完整查看</div>
		<!-- 老代码 -->
		<!-- <div class="information-top">
			<div class="name">{{ bedInfoByIdInformationList[0].name }}</div>
			<div class="sex">{{ bedInfoByIdInformationList[0].sexName }}</div>
			<div class="age">{{ bedInfoByIdInformationList[0].ageGroupName }}</div>
		</div>
		<div class="information-bottom">
			<div class="status">
			{{ bedInfoByIdInformationList[0].nursingLevelName }}
			</div>
			<div class="">
			{{ bedInfoByIdInformationList[0].actionAbilityName }}
			</div>
		</div>
		<div class="look" @click="checkInfo">完整查看</div> -->
    </div>
	<!-- 老代码 -->
    <!-- <div class="information" v-else>
      <div class="text-noData">提供用户基本信息，数据会更加精准</div>
    </div> -->
    <div class="show-report">
      <div class="button" @click="openHealthy">查看报告</div>
    </div>
    <div class="monitor-time">
      <div class="monitor-title">
        <div>开始监测</div>
        <div>结束监测</div>
      </div>
      <div class="monitor-time-con">
        <div
          class="monitor-time-item"
          v-for="(item, index) in timePeriods"
          :key="index"
        >
          <div class="begin-time">{{ item.startTime }}</div>
          <div class="monitor-icon">
            <img
              class="time-icon"
              src="./../../assets/img/right_icon.png"
              alt=""
              srcset=""
            />
          </div>
          <div class="end-time">{{ item.endTime }}</div>
        </div>
      </div>
    </div>
    <div class="history">
      <div class="history-top">
        <div class="history-text">历史信息</div>
        <div class="history-see" @click="handletoViewMore">查看更多</div>
      </div>
      <div class="history-con">
        <div
          class="history-con-item"
          v-for="(item, index) in bedEventList"
          :key="index"
        >
          <span>{{ item.time }}</span>
          <div
            style="display: inline-block; margin-left: 5px;"
            :style="{ color: hasSpanTag(item.content) ? '' : item.isAlarm === 1 ? 'rgba(255, 113, 134, 1)' : '' }"
            v-html="item.content"
          ></div>
        </div>
      </div>
    </div>
    <a-modal
      v-model="formVisible"
      footer=""
      :width="1000"
      :title="formTitle"
      class="lrck_TanWrap"
    >
      <div v-for="(wcItem, wcIndex) in inputForm" :key="wcIndex">
        <div :class="wcIndex != 0 ? 'lrck_tableWrap' : ''">
          <div class="tanUserInfoWrap">
            <div class="tanUlist">
              <div class="box">
                <div class="name">设备码</div>
                <div class="name2">{{ wcItem.snCode }}</div>
              </div>
              <div class="box">
                <div class="name">监测位置</div>
                <div class="name2 overhidFont" :title="wcItem.bedName" style="width:245px;">{{ wcItem.bedName }}</div>
              </div>
              <div class="box" v-if="wcItem.bindMobilePhone">
                <div class="name">绑定手机号</div>
                <div class="name2">{{ wcItem.bindMobilePhone}}</div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">姓名</div>
                <div class="name2" v-if="wcItem.bicVo.name || !isEditing">{{ wcItem.bicVo.name || wcItem.name}}</div>
                <div class="name2 name2_input_w205 pl5" v-if="isEditing && !wcItem.bicVo.name">
                  <el-input v-model="wcItem.name" placeholder="请输入姓名" size="medium"></el-input>
                </div>
              </div>
              <div class="box">
                <div class="name">性别</div>
                <div class="name2" v-if="wcItem.bicVo.sex" style="width:245px;">
                  <div v-if="wcItem.bicVo.sex == 1">男</div>
                  <div v-if="wcItem.bicVo.sex == 2" >女</div>
                  <div v-if="wcItem.bicVo.sex != 1 && wcItem.bicVo.sex != 2"> </div>
                </div>
                <div class="name2" v-if="!wcItem.bicVo.sex && !isEditing" style="width:245px;">
                  <div v-if="wcItem.sex == 1">男</div>
                  <div v-if="wcItem.sex == 2" >女</div>
                  <div v-if="wcItem.sex != 1 && wcItem.sex != 2"> </div>
                </div>
                <div class="name2 name2_input_w79 pl5" v-if="isEditing && !wcItem.bicVo.sex" style="width:245px;">
                  <el-select v-model="wcItem.sex" placeholder="" size="medium">
                    <el-option v-for="item in inputFormSelect.gender" :key="item.value" :label="item.label" :value="item.value" style="width: 195px" />
                  </el-select>
                </div>
              </div>
              <div class="box">
                <div class="name">年龄段</div>
                <div class="name2" v-if="!isEditing">
                  <div v-for="(item, index) in inputFormSelect.age" :key="index">
                    <div v-if="item.value == wcItem.ageGroup">
                      {{ inputFormSelect.age[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2 name2_input_w105 pl5" v-if="isEditing">
                  <el-select v-model="wcItem.ageGroup" placeholder="" size="medium">
                    <el-option v-for="item in inputFormSelect.age" :key="item.value" :label="item.label" :value="item.value" style="width: 195px" />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">出生日期</div>
                <div class="name2" v-if="wcItem.bicVo.birthday">{{ wcItem.bicVo.birthday }}</div>
                <div class="name2" v-if="!wcItem.bicVo.birthday && !isEditing">{{ wcItem.birthday }}</div>
                <div class="name2 name2_input_w205 pl5" v-if="!wcItem.bicVo.birthday && isEditing" @click="cliBirthTan(wcIndex)">
                  <a-popover
                    v-show="wcIndex == nowOper_birth_index"
                    v-model="showBirthday"
                    trigger="click"
                  >
                    <template slot="content">
                      <div :style="{ width: '300px', border: '1px solid #d9d9d9', borderRadius: '4px' }">
                        <a-calendar 
                          :defaultValue="$moment(wcItem.birthday, 'YYYY-MM-DD')"
                          :value="$moment(wcItem.birthday, 'YYYY-MM-DD')"
                          :fullscreen="false" 
                          @panelChange="panelChange" 
                          @select="changeDate"
                        />
                      </div>
                    </template>
                  </a-popover>
                  <el-input v-model="wcItem.birthday" placeholder="请选择出生日期" size="medium"></el-input>
                </div>
              </div>
              <div class="box">
                <div class="name">身份证号</div>
                <div class="name2" v-if="wcItem.bicVo.idCard" style="width:245px;">{{ wcItem.bicVo.idCard }}</div>
                <div class="name2" v-if="!wcItem.bicVo.idCard && !isEditing" style="width:245px;">{{ wcItem.idCard }}</div>

                <div class="name2 name2_input_w171 pl5" v-if="!wcItem.bicVo.idCard && isEditing" style="width:245px;">
                  <el-input v-model="wcItem.idCard"></el-input>
                </div>
                
              </div>
              <div class="box">
                <div class="name">紧急联系人</div>
                <div class="name2 overhidFont" style="width:160px" :title="wcItem.bicVo.mobilePhone" v-if="wcItem.bicVo.mobilePhone">{{ wcItem.bicVo.mobilePhone }}</div>
                <div class="name2 overhidFont" style="width:160px" :title="wcItem.bicVo.mobilePhone" v-if="!wcItem.bicVo.mobilePhone && !isEditing">{{ wcItem.mobilePhone }}</div>
                <div class="name2 name2_input_w171 pl5" v-if="!wcItem.bicVo.mobilePhone && isEditing">
                  <el-input v-model="wcItem.mobilePhone" oninput="value=value.replace(/[^\d]/g,'')" maxlength="11" placeholder="请输入手机号" size="medium"></el-input>
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">护理等级</div>
                <div class="name2" v-if="!isEditing">
                  <div v-for="(item, index) in inputFormSelect.nurGrade" :key="index">
                    <div v-if="item.value == wcItem.nursingLevel">
                      {{ inputFormSelect.nurGrade[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2 name2_input_w205 pl5" v-if="isEditing">
                  <el-select v-model="wcItem.nursingLevel" placeholder="请选择护理等级" size="medium">
                    <el-option v-for="item in inputFormSelect.nurGrade" :key="item.value" :label="item.label" :value="item.value" style="width: 195px" />
                  </el-select>
                </div>
              </div>
              <div class="box">
                <div class="name">行动能力</div>
                <div class="name2" v-if="wcItem.bicVo.actionAbility" style="width:245px;">
                  <div v-for="(item, index) in inputFormSelect.actAbility" :key="index">
                    <div v-if="item.value == wcItem.bicVo.actionAbility">
                      {{ inputFormSelect.actAbility[index].label }}
                    </div>
                  </div>
                </div>

                <div class="name2" v-if="!wcItem.bicVo.actionAbility && !isEditing" style="width:245px;">
                  <div v-for="(item, index) in inputFormSelect.actAbility" :key="index">
                    <div v-if="item.value == wcItem.actionAbility">
                      {{ inputFormSelect.actAbility[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2 name2_input_w150 pl5" v-if="!wcItem.bicVo.actionAbility && isEditing" style="width:245px;">
                  <el-select v-model="wcItem.actionAbility" placeholder="请选择行动能力" size="medium">
                    <el-option v-for="item in inputFormSelect.actAbility" :key="item.value" :label="item.label" :value="item.value" style="width: 195px" />
                  </el-select>
                </div>
              </div>
              <div class="box">
                <div class="name">行为状态</div>
				<div class="name2" style="width: 180px;" v-if="roleId == 2">
					<a-select
						v-if="isLoadLivingState && selectLivingState"
						v-model="selectLivingState"
						placeholder="请选择"
						option-filter-prop="children"
						style="width: 160px;"
						:filter-option="filterOption"
						@focus="handleFocus"
						@blur="handleBlur"
						@change="handleChange"
						dropdownClassName="my-ant-select-dropdown"
						class="my-ant-select"
					>
						<a-select-option :value="item" :key="index" v-for="(item, index) in ['不清楚', '行动自如', '失智', '半失能', '完全失能']">
						{{ item }}
						</a-select-option>
					</a-select>
					<a-select
						v-if="isLoadLivingState && !selectLivingState"
						placeholder="请选择"
						option-filter-prop="children"
						style="width: 160px;"
						:filter-option="filterOption"
						@focus="handleFocus"
						@blur="handleBlur"
						@change="handleChange"
						dropdownClassName="my-ant-select-dropdown"
						class="my-ant-select"
					>
						<a-select-option :value="item" :key="index" v-for="(item, index) in ['不清楚', '行动自如', '失智', '半失能', '完全失能']">
						{{ item }}
						</a-select-option>
					</a-select>
                  <!-- <div v-for="(item, index) in [1, 2, 3]" :key="index">
                    <div v-if="index == 0">
                      {{ item }}
                    </div>
                  </div> -->
                </div>
				<div class="name2" v-if="roleId == 3">
					{{ selectLivingState }}
                </div>
                <!-- <div class="name2" v-if="wcItem.bicVo.livingState">
                  <div v-for="(item, index) in inputFormSelect.living_state" :key="index">
                    <div v-if="item.value == wcItem.bicVo.livingState">
                      {{ inputFormSelect.living_state[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2" v-if="!wcItem.bicVo.livingState && !isEditing" style="width:245px;">
                  <div v-for="(item, index) in inputFormSelect.living_state" :key="index">
                    <div v-if="item.value == wcItem.livingState">
                      {{ inputFormSelect.living_state[index].label }}
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">呼吸</div>
                <div class="name2" v-if="wcItem.bicVo.breath">
                  <span v-for="(itemBreath,indexBreath) in wcItem.bicVo.breath" :key="indexBreath">
                    <span v-for="(item_inputFormSelect,index_inputFormSelect) in inputFormSelect.breath" :key="index_inputFormSelect">
                      <span v-if="itemBreath == item_inputFormSelect.value">
                        <span v-if="wcItem.bicVo.breath.length == 1">{{item_inputFormSelect.label}}</span>
                        <span v-if="wcItem.bicVo.breath.length > 1 && indexBreath != wcItem.bicVo.breath.length-1">{{item_inputFormSelect.label}}、</span>
                        <span v-if="wcItem.bicVo.breath.length > 1 && indexBreath == wcItem.bicVo.breath.length-1">{{item_inputFormSelect.label}}</span>
                      </span>
                    </span>
                  </span>
                </div>

                <div class="name2" v-if="!wcItem.bicVo.breath && !isEditing">
                  <span v-for="(itemBreath,indexBreath) in wcItem.breath" :key="indexBreath">
                    <span v-for="(item_inputFormSelect,index_inputFormSelect) in inputFormSelect.breath" :key="index_inputFormSelect">
                      <span v-if="itemBreath == item_inputFormSelect.value">
                        <span v-if="wcItem.breath.length == 1">{{item_inputFormSelect.label}}</span>
                        <span v-if="wcItem.breath.length > 1 && indexBreath != wcItem.breath.length-1">{{item_inputFormSelect.label}}、</span>
                        <span v-if="wcItem.breath.length > 1 && indexBreath == wcItem.breath.length-1">{{item_inputFormSelect.label}}</span>
                      </span>
                    </span>
                  </span>
                </div>
                <div class="name2 name2_input_w205 pl5" v-if="!wcItem.bicVo.breath && isEditing" style="width:500px;">
                  <span v-for="(itemBreath,indexBreath) in wcItem.breath" :key="indexBreath">
                    <el-select v-model="wcItem.breath[indexBreath]" placeholder="请选择呼吸问题" size="medium">
                      <el-option v-for="item in inputFormSelect.breath" :key="item.value" :label="item.label" :value="item.value" style="width: 195px" />
                    </el-select>
                    &nbsp;
                  </span>
                  <img class="cursorPointer" src="../../assets/jia.png" style="width:18px;" v-if="wcItem.breath.length < 2" @click="deleteBreath(0,wcIndex)"/>
                  <!-- <a-icon type="plus-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.breath.length < 2" @click="deleteBreath(0,wcIndex)" /> -->
                  &nbsp;
                  <a-icon type="close-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.breath.length > 1" @click="deleteBreath(1,wcIndex)" />
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">心脏</div>
                <div class="name2" v-if="wcItem.bicVo.heart">
                  <span v-for="(itemHeart,indexHeart) in wcItem.bicVo.heart" :key="indexHeart">
                    <span v-for="(item_inputFormSelect,index_inputFormSelect) in inputFormSelect.heart" :key="index_inputFormSelect">
                      <span v-if="itemHeart == item_inputFormSelect.value">
                        <span v-if="wcItem.bicVo.heart.length == 1">{{item_inputFormSelect.label}}</span>
                        <span v-if="wcItem.bicVo.heart.length > 1 && indexHeart != wcItem.bicVo.heart.length-1">{{item_inputFormSelect.label}}、</span>
                        <span v-if="wcItem.bicVo.heart.length > 1 && indexHeart == wcItem.bicVo.heart.length-1">{{item_inputFormSelect.label}}</span>
                      </span>
                    </span>
                  </span>
                </div>

                <div class="name2" v-if="!wcItem.bicVo.heart && !isEditing">
                  <span v-for="(itemHeart,indexHeart) in wcItem.heart" :key="indexHeart">
                    <span v-for="(item_inputFormSelect,index_inputFormSelect) in inputFormSelect.heart" :key="index_inputFormSelect">
                      <span v-if="itemHeart == item_inputFormSelect.value">
                        <span v-if="wcItem.heart.length == 1">{{item_inputFormSelect.label}}</span>
                        <span v-if="wcItem.heart.length > 1 && indexHeart != wcItem.heart.length-1">{{item_inputFormSelect.label}}、</span>
                        <span v-if="wcItem.heart.length > 1 && indexHeart == wcItem.heart.length-1">{{item_inputFormSelect.label}}</span>
                      </span>
                    </span>
                  </span>
                </div>
                <div class="name2 name2_input_w205 pl5" v-if="!wcItem.bicVo.heart && isEditing" style="width:500px;">
                  <span v-for="(itemHeart,indexHeart) in wcItem.heart" :key="indexHeart">
                    <el-select v-model="wcItem.heart[indexHeart]" placeholder="请选择心脏问题" size="medium">
                      <el-option v-for="item in inputFormSelect.heart" :key="item.value" :label="item.label" :value="item.value" style="width: 195px" />
                    </el-select>
                    &nbsp;
                  </span>
                  <img class="cursorPointer" src="../../assets/jia.png" style="width:18px;" v-if="wcItem.heart.length < 2" @click="deleteHeart(0,wcIndex)"/>
                  <!-- <a-icon type="plus-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.heart.length < 2" @click="deleteHeart(0,wcIndex)" /> -->
                  &nbsp;
                  <a-icon type="close-circle" theme="twoTone" two-tone-color="#1890ff" v-if="wcItem.heart.length > 1" @click="deleteHeart(1,wcIndex)" />
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">睡眠状况</div>
              </div>
              <div style="background:#f0f0f0;width:calc(100% - 82px);height:100%;"></div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">是否失眠</div>
                <div class="name2" v-if="wcItem.bicVo.insomnia">
                  <div v-for="(item, index) in inputFormSelect.insomnia" :key="index">
                    <div v-if="item.value == wcItem.bicVo.insomnia">
                      {{ inputFormSelect.insomnia[index].label }}
                    </div>
                  </div>
                </div>

                <div class="name2" v-if="!wcItem.bicVo.heart && !isEditing">
                  <div v-for="(item, index) in inputFormSelect.insomnia" :key="index">
                    <div v-if="item.value == wcItem.insomnia">
                      {{ inputFormSelect.insomnia[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2 name2_input_w205 pl5" v-if="!wcItem.bicVo.heart && isEditing">
                  <el-select v-model="wcItem.insomnia" placeholder="" size="medium">
                    <el-option v-for="item in inputFormSelect.insomnia" :key="item.value" :label="item.label" :value="item.value" style="width: 195px" />
                  </el-select>
                </div>
              </div>
              <div class="box">
                <div class="name">是否打呼噜</div>
                <div class="name2" v-if="wcItem.bicVo.snore" style="width:245px;">
                  <div v-for="(item, index) in inputFormSelect.snore" :key="index">
                    <div v-if="item.value == wcItem.bicVo.snore">
                      {{ inputFormSelect.snore[index].label }}
                    </div>
                  </div>
                </div>

                <div class="name2" v-if="!wcItem.bicVo.snore && !isEditing" style="width:245px;">
                  <div v-for="(item, index) in inputFormSelect.snore" :key="index">
                    <div v-if="item.value == wcItem.snore">
                      {{ inputFormSelect.snore[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2 name2_input_w79 pl5" v-if="!wcItem.bicVo.snore && isEditing" style="width:245px;">
                  <el-select v-model="wcItem.snore" placeholder="" size="medium">
                    <el-option v-for="item in inputFormSelect.snore" :key="item.value" :label="item.label" :value="item.value" style="width: 195px" />
                  </el-select>
                </div>
              </div>
              <div class="box">
                <div class="name">起夜频次</div>
                <div class="name2" v-if="!isEditing" style="width:245px;">
                  <div v-for="(item, index) in inputFormSelect.night_frequency" :key="index">
                    <div v-if="item.value == wcItem.nightFrequency">
                      {{ inputFormSelect.night_frequency[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2 name2_input_w79 pl5" v-if="isEditing" style="width:245px;">
                  <el-select v-model="wcItem.nightFrequency" placeholder="" size="medium">
                    <el-option v-for="item in inputFormSelect.night_frequency" :key="item.value" :label="item.label" :value="item.value" style="width: 195px" />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name" style="width:166px;">已知睡眠呼吸障碍疾病</div>
                <div class="name2" v-if="wcItem.bicVo.sleepDisorderedBreathing">
                  <span v-for="(itemSdb,indexSdb) in wcItem.bicVo.sleepDisorderedBreathing" :key="indexSdb">
                    <span v-for="(item_inputFormSelect,index_inputFormSelect) in inputFormSelect.sleepDisorderedBreathing" :key="index_inputFormSelect">
                      <span v-if="itemSdb == item_inputFormSelect.value">
                        <span v-if="wcItem.bicVo.sleepDisorderedBreathing.length == 1">{{item_inputFormSelect.label}}</span>
                        <span v-if="wcItem.bicVo.sleepDisorderedBreathing.length > 1 && indexSdb != wcItem.bicVo.sleepDisorderedBreathing.length-1">{{item_inputFormSelect.label}}、</span>
                        <span v-if="wcItem.bicVo.sleepDisorderedBreathing.length > 1 && indexSdb == wcItem.bicVo.sleepDisorderedBreathing.length-1">{{item_inputFormSelect.label}}</span>
                      </span>
                    </span>
                  </span>
                </div>
                <div class="name2" v-if="!wcItem.bicVo.sleepDisorderedBreathing && !isEditing">
                  <span v-for="(itemSdb,indexSdb) in wcItem.sleepDisorderedBreathing" :key="indexSdb">
                    <span v-for="(item_inputFormSelect,index_inputFormSelect) in inputFormSelect.sleepDisorderedBreathing" :key="index_inputFormSelect">
                      <span v-if="itemSdb == item_inputFormSelect.value">
                        <span v-if="wcItem.sleepDisorderedBreathing.length == 1">{{item_inputFormSelect.label}}</span>
                        <span v-if="wcItem.sleepDisorderedBreathing.length > 1 && indexSdb != wcItem.sleepDisorderedBreathing.length-1">{{item_inputFormSelect.label}}、</span>
                        <span v-if="wcItem.sleepDisorderedBreathing.length > 1 && indexSdb == wcItem.sleepDisorderedBreathing.length-1">{{item_inputFormSelect.label}}</span>
                      </span>
                    </span>
                  </span>
                </div>
                <!-- <div class="name2 name2_input_w205 pl5" v-if="isEditing"> -->
                <div class="pl5" v-if="!wcItem.bicVo.sleepDisorderedBreathing && isEditing">
                  <el-checkbox-group v-model="wcItem.sleepDisorderedBreathing">
                    <el-checkbox label="1">呼吸暂停</el-checkbox>
                    <span style="padding: 0 30px 0 0">
                      <el-checkbox label="2">慢阻肺</el-checkbox>
                    </span>
                    <el-checkbox label="3">低通气</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">跌倒史</div>
                <div class="name2" v-if="!isEditing">
                  <div
                    v-for="(item, index) in inputFormSelect.fallHistory"
                    :key="index"
                  >
                    <div v-if="item.value == wcItem.fallHistory">
                      {{ inputFormSelect.fallHistory[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2 name2_input_w205 pl5" v-if="isEditing">
                  <el-select
                    v-model="wcItem.fallHistory"
                    placeholder="请选择跌倒史"
                    size="medium"
                  >
                    <el-option
                      v-for="item in inputFormSelect.fallHistory"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      style="width: 195px"
                    />
                  </el-select>
                </div>
              </div>
              <div class="box">
                <div class="name" style="width:138px;">有超过一个医学判断</div>
                <div class="name2" v-if="!isEditing" style="width:245px;">
                  <div
                    v-for="(item, index) in inputFormSelect.medicalDiagnosis"
                    :key="index"
                  >
                    <div v-if="item.value == wcItem.medicalDiagnosis">
                      {{ inputFormSelect.medicalDiagnosis[index].label }}
                    </div>
                  </div>
                </div>
                <div
                  class="name2 name2_input_w79 pl5"
                  v-if="isEditing"
                  style="width:245px;"
                >
                  <el-select
                    v-model="wcItem.medicalDiagnosis"
                    placeholder=""
                    size="medium"
                  >
                    <el-option
                      v-for="item in inputFormSelect.medicalDiagnosis"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      style="width: 195px"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name" style="width:208px;">
                  静脉输液/置管/使用特殊药物
                </div>
                <div class="name2" v-if="!isEditing">
                  <div
                    v-for="(item, index) in inputFormSelect.infusion"
                    :key="index"
                  >
                    <div v-if="item.value == wcItem.infusion">
                      {{ inputFormSelect.infusion[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2 name2_input_w79 pl5" v-if="isEditing">
                  <el-select
                    v-model="wcItem.infusion"
                    placeholder="请选择跌倒史"
                    size="medium"
                  >
                    <el-option
                      v-for="item in inputFormSelect.infusion"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      style="width: 195px"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">步态</div>
                <div class="name2" v-if="!isEditing">
                  <div
                    v-for="(item, index) in inputFormSelect.gait"
                    :key="index"
                  >
                    <div v-if="item.value == wcItem.gait">
                      {{ inputFormSelect.gait[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2 name2_input_w205 pl5" v-if="isEditing">
                  <el-select
                    v-model="wcItem.gait"
                    placeholder="请选择步态"
                    size="medium"
                  >
                    <el-option
                      v-for="item in inputFormSelect.gait"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      style="width: 195px"
                    />
                  </el-select>
                </div>
              </div>
              <div class="box">
                <div class="name">认知状态</div>
                <div class="name2" style="width:340px;" v-if="!isEditing">
                  <div
                    v-for="(item, index) in inputFormSelect.cognitiveState"
                    :key="index"
                  >
                    <div v-if="item.value == wcItem.cognitiveState">
                      {{ inputFormSelect.cognitiveState[index].label }}
                    </div>
                  </div>
                </div>
                <div class="name2 name2_input_w340 pl5" v-if="isEditing">
                  <el-select
                    v-model="wcItem.cognitiveState"
                    placeholder="请选择认知状态"
                    size="medium"
                  >
                    <el-option
                      v-for="item in inputFormSelect.cognitiveState"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      style="width: 340px"
                    />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="tanUlist">
              <div class="box">
                <div class="name">备注</div>
                <div
                  class="name2"
                  style="width:860px;overflow-x: auto;white-space: nowrap;"
                  v-if="!isEditing"
                >
                  {{ wcItem.remarks }}
                </div>
                <div class="name2 name2_input_w860 pl5" v-if="isEditing">
                  <el-input
                    v-model="wcItem.remarks"
                    placeholder="可备注长者的其他信息"
                    size="medium"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clear mt20">
        <div style="float: right">
          <!-- <el-button v-if="!isEditing" @click="onEdit()">编辑</el-button> -->
          <el-button v-if="!isEditing" @click="formVisible = false"
            >关闭</el-button
          >
          <div v-if="isEditing">
            <el-button type="primary" @click="onSubmit">确定</el-button>
            <el-button @click="formVisible = false">关闭</el-button>
          </div>
        </div>
      </div>
    </a-modal>
	<a-modal title="温馨提示" :width="400" :visible="isShowTipAlertWqsn" :maskClosable="false" :footer="null"
		@cancel="tipAlertClickCancelWqsn" :zIndex="1000">
		<div style="display: block; align-items: center; margin-top: 10px; margin-bottom: 20px;">
			<img style="width: 16px; height: 16px; display: inline; margin-right: 5px; margin-top: -2px;" src="./../../assets/icon_alert_warning.png" alt="" />
			<div style="font-family: PingFangSC, PingFang SC; font-weight: 400; font-size: 14px; color: #58595A; line-height: 20px; display: inline;">设置成“完全失能”后，老人的监测时段会自动升级为24小时，离床报警的时长为2分30秒，这是我们建议最适合完全失能老人的设置，确定设置吗？</div>
		</div>
		<div class="addBtn toitet-btn" style="margin-left: 210px;">
			<a-button style="margin-right: 10px" @click="tipAlertClickCancelWqsn">取消</a-button>
			<a-button type="primary" @click="tipAlertClickSureWqsn">确定</a-button>
		</div>
	</a-modal>
  </div>
</template>
<script>
import Global from '../../utils/global';
export default {
  props: {
    pageBottomData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      inputFormSelectRaw: {},
      inputFormSelect: {},
      isEditing: false,
      inputForm: [],
      formTitle: '',
      formVisible: false,
      bedInfoByIdInformationList: [
        {
          actionAbilityName: '',
          ageGroupName: '',
          name: '',
          nursingLevelName: '',
          sexName: '',
        },
      ],
      timePeriods: [{ bedId: '', endTime: '', id: '', startTime: '' }],
      bedEventList: [
        {
          content: '',
          isAlarm: '',
          time: '',
        },
      ],
	  isShowTipAlertWqsn: false,

	  living_state: [
		{
			name: '不清楚',
			key: 0
		},
		{
			name: '行动自如',
			key: 1
		},
		{
			name: '失智',
			key: 2
		},
		{
			name: '半失能',
			key: 3
		},
		{
			name: '完全失能',
			key: 4
		}
      ],

	  isLoadLivingState: false,
	  selectLivingState: null,
	  oldSelectLivingState: null,

	  roleId: this.$getCookie('userInfo').user.roleId


    };
  },
  created() {
    console.log(
      this.pageBottomData,
      'this.pageBottomDatathis.pageBottomDatathis.pageBottomDatathis.pageBottomData'
    );
  },
  mounted() {
    setTimeout(() => {
      this.bedInfoByIdInformationList = this.pageBottomData.bedInfoByIdInformationList;
      this.timePeriods = this.pageBottomData && this.pageBottomData.monitorInfoVO && this.pageBottomData.monitorInfoVO.timePeriods ? this.pageBottomData.monitorInfoVO.timePeriods : [{ bedId: '', endTime: '', id: '', startTime: '' }];
      
	 // 旧代码
	//   this.bedEventList = this.pageBottomData.bedEventList;

		// 新代码 - 需要单独调用一个接口
		this.getEventLogHistoryById();
	  
	  if (this.bedInfoByIdInformationList && this.bedInfoByIdInformationList.length > 0 && this.bedInfoByIdInformationList[0].livingState != null) {
		if (this.bedInfoByIdInformationList[0].livingState == 0) {
			this.selectLivingState = "不清楚"
		} else if (this.bedInfoByIdInformationList[0].livingState == 1) {
			this.selectLivingState = "行动自如"
		} else if (this.bedInfoByIdInformationList[0].livingState == 2) {
			this.selectLivingState = "失智"
		} else if (this.bedInfoByIdInformationList[0].livingState == 3) {
			this.selectLivingState = "半失能"
		} else if (this.bedInfoByIdInformationList[0].livingState == 4) {
			this.selectLivingState = "完全失能"
		}
	  }
	//   if (this.bicVo && this.bicVo.livingState) {
	// 	this.selectLivingState = this.bicVo.livingState;
	//   }
	  this.isLoadLivingState = true;
    });
    this.getBedInfo();
  },
  watch: {
	selectLivingState(newVal,oldVal) {
		this.oldSelectLivingState = oldVal;
	},
	pageBottomData(newVal, oldVal) {
		if (newVal) {
			this.getEventLogHistoryById();
		}
	}
  },
  methods: {
	handleChange(value) {
		if (value == '完全失能') {
			this.isShowTipAlertWqsn = true;
		} else {
			let tempDic = {
				"不清楚": 0,
				"行动自如": 1,
				"失智": 2,
				"半失能": 3,
				"完全失能": 4,

			}
			this.$post(
				'/api/bedInformation/changeLivingState',
				{
					"snCode": this.pageBottomData.sn,
					"livingState": tempDic[value]
				},
				(res) => {
					if (res.code == 0) {
					} else {
						this.$message.error(res.msg);
					}
				},
				(err) => {
					// this.$message.error('服务端发生异常');
				}
			);
		}
        console.log(`selected ${value}`);
    },
    handleBlur() {
      console.log('blur');
    },
    handleFocus() {
      console.log('focus');
    },
    filterOption(input, option) {
		console.log('===1===', input, option)
		return false
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
	tipAlertClickCancelWqsn() {
		this.isShowTipAlertWqsn = false;
		this.selectLivingState = this.oldSelectLivingState;
	},
	tipAlertClickSureWqsn() {
		this.isShowTipAlertWqsn = false;
		this.$post(
			'/api/bedInformation/changeLivingState',
			{
				"snCode": this.pageBottomData.sn,
				"livingState": 4
			},
			(res) => {
				if (res.code == 0) {
				} else {
					this.$message.error(res.msg);
				}
			},
			(err) => {
				// this.$message.error('服务端发生异常');
			}
		);
	},
	hasSpanTag(content) {
		if (!content) {
			return false;
		}
		return content.indexOf('<span') !== -1;
	},
    handletoViewMore() {
      console.log(this.$parent.navText2);
      Global.$emit('handleName', {
        e: this.$parent.navText2,
        type: 0,
      });
      let path = '';
      if (this.$getCookie('userInfo').user.roleId == 2) {
        path = '/dean/moreBed';
      } else if (this.$getCookie('userInfo').user.roleId == 3) {
        path = '/protect/moreBed';
      }
      this.$router.push({
        path: path,
        query: {
          bedId: this.$route.query.id || this.pageBottomData.bedId,
          is: 1,
        },
      });
    },
    openHealthy() {
      this.$emit('openHealthy', this.pageBottomData);
    },
    checkInfo() {
      //  this.$route.query.id || this.bedId 262
      let parasm = {
        bedId: this.$route.query.id || this.pageBottomData.bedId,
      };
      this.$get(
        '/api/bedInformation/getByBedId',
        parasm,
        (res) => {
          if (res.code == 0) {
            this.inputForm = res.data;
            this.formVisible = true;
            this.formTitle = '床位信息';
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    getBedInfo() {
      this.$get(
        '/api/bedInformation/getType',
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.inputFormSelectRaw = res.data;
              this.getInputFormSelect();
            } else {
              this.$message.error(res.msg);
            }
          }
        },
        (err) => {
          console.log(err);
          // // this.$message.error("服务端发生异常");
        }
      );
    },
	getEventLogHistoryById() {
		if (!(this.$route.query.id || this.pageBottomData.bedId)) {
			return
		}
		let parasm = {
			bedId: this.$route.query.id || this.pageBottomData.bedId,
		};
		this.$get(
			'/api/v3/bed/getEventLogHistoryById',
			parasm,
			(res) => {
				if (res.code == 0) {
					this.bedEventList = res.data.bedEventList;
				}
			},
			(err) => {
			console.log(err);
			}
		);
	},

    // 下拉框处理逻辑
    getInputFormSelect() {
      //性别
      var g = [];
      for (var i = 0; i < this.inputFormSelectRaw.sex.length; i++) {
        for (var key in this.inputFormSelectRaw.sex[i]) {
          g.push({
            value: Number(key),
            label: this.inputFormSelectRaw.sex[i][key],
          });
        }
      }
      this.inputFormSelect['gender'] = g;
      //年龄段
      var ag = [];
      for (var i = 0; i < this.inputFormSelectRaw.age_group.length; i++) {
        for (var key in this.inputFormSelectRaw.age_group[i]) {
          ag.push({
            value: Number(key),
            label: this.inputFormSelectRaw.age_group[i][key],
          });
        }
      }
      this.inputFormSelect['age'] = ag;
      //护理等级
      var ng = [];
      for (var i = 0; i < this.inputFormSelectRaw.nursing_level.length; i++) {
        for (var key in this.inputFormSelectRaw.nursing_level[i]) {
          ng.push({
            value: Number(key),
            label: this.inputFormSelectRaw.nursing_level[i][key],
          });
        }
      }
      this.inputFormSelect['nurGrade'] = ng;
      //行动能力
      var aa = [];
      for (var i = 0; i < this.inputFormSelectRaw.action_ability.length; i++) {
        for (var key in this.inputFormSelectRaw.action_ability[i]) {
          aa.push({
            value: Number(key),
            label: this.inputFormSelectRaw.action_ability[i][key],
          });
        }
      }
      this.inputFormSelect['actAbility'] = aa;
      //行为状态
      var xwzt = [];
      for (var i = 0; i < this.inputFormSelectRaw.living_state.length; i++) {
        for (var key in this.inputFormSelectRaw.living_state[i]) {
          xwzt.push({
            value: Number(key),
            label: this.inputFormSelectRaw.living_state[i][key],
          });
        }
      }
      this.inputFormSelect["living_state"] = xwzt;
      //呼吸
      var b = [];
      for (var i = 0; i < this.inputFormSelectRaw.breath.length; i++) {
        for (var key in this.inputFormSelectRaw.breath[i]) {
          b.push({
            value: key,
            label: this.inputFormSelectRaw.breath[i][key],
          });
        }
      }
      this.inputFormSelect['breath'] = b;
      //心脏
      var h = [];
      for (var i = 0; i < this.inputFormSelectRaw.heart.length; i++) {
        for (var key in this.inputFormSelectRaw.heart[i]) {
          h.push({ value: key, label: this.inputFormSelectRaw.heart[i][key] });
        }
      }
      this.inputFormSelect['heart'] = h;
      //是否失眠
      var ins = [];
      for (var i = 0; i < this.inputFormSelectRaw.insomnia.length; i++) {
        for (var key in this.inputFormSelectRaw.insomnia[i]) {
          ins.push({
            value: Number(key),
            label: this.inputFormSelectRaw.insomnia[i][key],
          });
        }
      }
      this.inputFormSelect['insomnia'] = ins;
      //是否打呼噜
      var s = [];
      for (var i = 0; i < this.inputFormSelectRaw.snore.length; i++) {
        for (var key in this.inputFormSelectRaw.snore[i]) {
          s.push({
            value: Number(key),
            label: this.inputFormSelectRaw.snore[i][key],
          });
        }
      }
      this.inputFormSelect['snore'] = s;
      //起夜频次
      var no = [];
      for (var i = 0; i < this.inputFormSelectRaw.night_frequency.length; i++) {
        for (var key in this.inputFormSelectRaw.night_frequency[i]) {
          no.push({
            value: Number(key),
            label: this.inputFormSelectRaw.night_frequency[i][key],
          });
        }
      }
      this.inputFormSelect['night_frequency'] = no;
      //已知睡眠呼吸障碍疾病
      var cnm = [];
      for (
        var i = 0;
        i < this.inputFormSelectRaw.sleep_disordered_breathing.length;
        i++
      ) {
        for (var key in this.inputFormSelectRaw.sleep_disordered_breathing[i]) {
          cnm.push({
            value: Number(key),
            label: this.inputFormSelectRaw.sleep_disordered_breathing[i][key],
          });
        }
      }
      this.inputFormSelect['sleepDisorderedBreathing'] = cnm;
      // 跌倒史
      let fall_history = [];
      for (let i = 0; i < this.inputFormSelectRaw.fall_history.length; i++) {
        for (let key in this.inputFormSelectRaw.fall_history[i]) {
          fall_history.push({
            value: Number(key),
            label: this.inputFormSelectRaw.fall_history[i][key],
          });
        }
      }
      this.inputFormSelect['fallHistory'] = fall_history;
      // 有超过1个医学诊断
      let medical_diagnosis = [];
      for (
        let i = 0;
        i < this.inputFormSelectRaw.medical_diagnosis.length;
        i++
      ) {
        for (let key in this.inputFormSelectRaw.medical_diagnosis[i]) {
          medical_diagnosis.push({
            value: Number(key),
            label: this.inputFormSelectRaw.medical_diagnosis[i][key],
          });
        }
      }
      this.inputFormSelect['medicalDiagnosis'] = medical_diagnosis;
      // 静脉输液/置管/使用特殊药物
      let infusion = [];
      for (let i = 0; i < this.inputFormSelectRaw.infusion.length; i++) {
        for (let key in this.inputFormSelectRaw.infusion[i]) {
          infusion.push({
            value: Number(key),
            label: this.inputFormSelectRaw.infusion[i][key],
          });
        }
      }
      this.inputFormSelect['infusion'] = infusion;
      // 步态
      let gait = [];
      for (let i = 0; i < this.inputFormSelectRaw.gait.length; i++) {
        for (let key in this.inputFormSelectRaw.gait[i]) {
          gait.push({
            value: Number(key),
            label: this.inputFormSelectRaw.gait[i][key],
          });
        }
      }
      this.inputFormSelect['gait'] = gait;
      // 认知状态
      let cognitive_state = [];
      for (let i = 0; i < this.inputFormSelectRaw.cognitive_state.length; i++) {
        for (let key in this.inputFormSelectRaw.cognitive_state[i]) {
          cognitive_state.push({
            value: Number(key),
            label: this.inputFormSelectRaw.cognitive_state[i][key],
          });
        }
      }
      this.inputFormSelect['cognitiveState'] = cognitive_state;
      console.log('inputFormSelect====', this.inputFormSelect);
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
.page-bottom {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  .text-noData {
    padding: 35px 10px;
    text-align: center;
  }
  .information {
    width: 200px;
    height: 125px;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    box-shadow: 0px 3px 6px -2px rgb(0 0 0 / 12%);
    border-radius: 8px;
    .information-top {
      margin-top: 20px;
    }
    .information-bottom {
      margin-top: 10px;
      margin-bottom: 13px;
    }
    .information-top,
    .information-bottom {
      display: flex;
      div {
        margin-left: 20px;
      }
    }
    .look {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1890ff;
      cursor: pointer;
    }
  }
  .show-report {
    width: 142px;
    height: 125px;
    background: #ffffff;
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    .button {
      width: 102px;
      height: 36px;
      background: #1890ff;
      border-radius: 19px;
      font-size: 14px;
      font-weight: 400;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
    }
  }
  .monitor-time {
    width: 206px;
    height: 125px;
    background: #ffffff;
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .monitor-title {
      width: 100%;
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
      color: #8c8c8c;
    }
    .monitor-time-con {
      flex: 1;
      width: 80%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-bottom: 20px;
      .monitor-time-item {
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        color: #262626;
        .time-icon {
          width: 30px;
          height: 25px;
        }
      }
    }
  }
  .history {
    flex: 1;
    margin-left: 10px;
    min-height: 125px;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 3px 6px -2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    padding: 10px 20px 10px 20px;
    .history-top {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .history-text {
        font-size: 18px;
        font-weight: 400;
        color: #262626;
        line-height: 24px;
      }
      .history-see {
        color: #1890ff;
        cursor: pointer;
      }
    }
    .history-con {
      flex: 1;
      width: 100%;
      max-width: 622px;
      display: flex;
      flex-direction: column;
      .history-con-item {
        margin: 5px 0 0;
      }
    }
  }
}
</style>

<style>
.my-ant-select .ant-select-selection .ant-select-selection__rendered .ant-select-selection-selected-value {
	color: rgba(38, 38, 38, 1) !important;
}
.my-ant-select-dropdown {
	.ant-select-dropdown-menu-item {
		color: rgba(38, 38, 38, 1) !important;
	}
	.ant-select-dropdown-menu-item-selected {
		color: rgba(24, 144, 255, 1) !important;
		font-weight: 400 !important;
	}
}
</style>